import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent } from './FormContent';

export const CompanyKnowledgeAndExperienceSection = () => {
  const { t } = useTranslation();
  return (
    <Section
      datax="knowledgeAndExperienceSection"
      title={t('client.legal.legalKnowledgeAndExperience.title')}
    >
      <FormContent />
    </Section>
  );
};
